var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira-original-a",
    gradientUnits: "userSpaceOnUse",
    x1: 22.034,
    y1: 9.773,
    x2: 17.118,
    y2: 14.842,
    gradientTransform: "scale(4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira-original-b",
    gradientUnits: "userSpaceOnUse",
    x1: 16.641,
    y1: 15.564,
    x2: 10.957,
    y2: 21.094,
    gradientTransform: "scale(4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.023 16H61.805c0 11.52 9.324 20.848 20.847 20.848h8.5v8.226c0 11.52 9.328 20.848 20.848 20.848V19.977A3.98 3.98 0 00108.023 16zm0 0",
    fill: "#2684ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.121 39.04H38.902c0 11.519 9.325 20.847 20.844 20.847h8.504v8.226c0 11.52 9.328 20.848 20.848 20.848V43.016a3.983 3.983 0 00-3.977-3.977zm0 0",
    fill: "url(#jira-original-a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.219 62.078H16c0 11.524 9.324 20.848 20.848 20.848h8.5v8.23c0 11.52 9.328 20.844 20.847 20.844V66.059a3.984 3.984 0 00-3.976-3.98zm0 0",
    fill: "url(#jira-original-b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/Jira.b894f17b42eb499ba8a4c4cecbb58a99.svg";
export { ForwardRef as ReactComponent };